<div class="d-flex align-items-center overflow-hidden flex-nowrap">
  <div class="d-flex align-items-center" style="height: fit-content">
    <ng-container *ngFor="let option of options">
      <div
        class="flex-shrink-0"
        [ngStyle]="{ 'max-width': maxW }"
        [ngClass]="fontSmaller ? 'me-1' : fontResize ? 'me-1' : 'me-2'"
        *ngIf="1 == 1"
      >
        <div
          class="p-0 w-100 d-flex align-items-center justify-content-center rounded-3"
        >
          <div
            class="card p-0 m-0 position-relative w-100 overflow-hidden"
            style="max-width: 560px"
            [style.background-color]="transparent ? 'rgba(0,0,0,0)' : null"
            [ngClass]="[
              fontSmaller
                ? card_sec
                  ? card_sec
                  : ''
                : card_round
                  ? card_round
                  : 'rounded-3',
              outlined ? 'border border-1' : 'border-0',
            ]"
            [ngStyle]="{
              'box-shadow': shadow
                ? '0px 3px 9px -5px rgba(66, 68, 90, 1)'
                : 'none',
            }"
            [style]="'border-color:' + border_color + '!important'"
          >
            <img [src]="emptyImage" class="card-img" alt="empty" />
            <div
              class="card-img-overlay p-0"
              [ngStyle]="!transparent ? setButtonBg(option.image, option) : null"
              [ngClass]="fontSmaller ? '' : sec_round ? sec_round : 'rounded-3'"
            >
              <div class="position-absolute start-0 end-0">
                <div
                  *ngIf="albums && albums[0]?.en"
                  class="card m-0 p-0 shadow-none rounded-0"
                  style="background-color: rgba(0,0,0,{{
                    albums[0].opacity
                  }}); max-width: 560px; backdrop-filter: blur({{
                    albums[0].blur
                  }})"
                  [class.h-100]="styleP0 === 5"
                >
                  <img [src]="emptyImageP0" alt="empty" class="card-img" [class.h-100]="styleP0 === 5" />
                  <div
                    class="card-img-overlay border overflow-hidden m-0 p-0"
                    [ngClass]="
                      debug ? 'border-1 ' : 'border-0 ' + albums[0]?.round
                    "
                  >
                    <ng-template [ngTemplateOutlet]="part_0"></ng-template>
                  </div>
                </div>

                <div
                  *ngIf="albums && albums[1]?.en"
                  class="card m-0 p-0 shadow-none"
                  ngClass="{{ albums[1].round }}"
                  style="background-color: rgba(0,0,0,{{
                    albums[1].opacity
                  }}); max-width: 560px ; backdrop-filter: blur({{
                    albums[1].blur
                  }})"
                  [ngStyle]="setTitleBg"
                >
                  <img [src]="emptyImageP1" alt="empty" class="card-img" />
                  <div
                    class="card-img-overlay border overflow-hidden m-0 p-0"
                    [ngClass]="debug ? 'border-1' : 'border-0'"
                  >
                    <ng-template [ngTemplateOutlet]="part_1"></ng-template>
                  </div>
                </div>

                <div
                  *ngIf="albums && albums[2]?.en"
                  class="card m-0 p-0 shadow-none"
                  ngClass="{{ albums[2].round }}"
                  style="background-color: rgba(0,0,0,{{
                    albums[2].opacity
                  }}); max-width: 560px ; backdrop-filter: blur({{
                    albums[2].blur
                  }})"
                  [ngStyle]="setTitleBg"
                >
                  <img [src]="emptyImageP2" alt="empty" class="card-img" />
                  <div
                    class="card-img-overlay border overflow-hidden m-0 p-0"
                    [ngClass]="debug ? 'border-1' : 'border-0'"
                  >
                    <ng-template [ngTemplateOutlet]="part_2"></ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #part_0>
        <div *ngIf="styleP0 == 0" class="row m-0 p-0"></div>
        <!-- ********the image in center*********** -->
        <div *ngIf="styleP0 == 1" class="row m-0 p-0">
          <div
            class="col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle"
          >
            <img
              [src]="option.image"
              class="object-fit-cover mx-auto d-block"
              [ngStyle]="{ width: widthP0 }"
              *ngIf="option.image"
            />
          </div>
        </div>
        <!-- ********the image in background*********** -->
        <div *ngIf="styleP0 == 2" class="row m-0 p-0">
          <div class="col-12 p-0 m-0">
            <img
              [src]="option.image"
              class="object-fit-cover mx-auto d-block"
              [ngStyle]="{ width: widthP0, 'aspect-ratio': 1 }"
              *ngIf="option.image"
              ngClass="{{ albums[0].image_round }}"
            />
            <!-- <div class="card-img-overlay p-0" [ngStyle]="setImageP1" *ngIf="image"></div> -->
          </div>
        </div>
        <!-- ********the image & text togther*********** -->
        <div
          *ngIf="styleP0 == 3"
          class="row m-0 p-0 d-flex align-items-center justify-content-center h-100"
        >
          <div
            class="col-5 m-0 ps-0 pt-0 pb-0 h-100"
            [ngStyle]="{ padding: fontSmaller ? '0px' : albums[0].padding }"
          >
            <img
              [src]="option.image"
              class="object-fit-cover d-block"
              [ngStyle]="{ width: widthP0, height: widthP0 }"
              *ngIf="option.image"
              ngClass="{{ albums[0].image_round }}"
            />
          </div>
          <div
            class="col-7 m-0 text-wrap mb-0"
            [ngStyle]="{ padding: fontSmaller ? '0px' : albums[0].padding }"
          >
            <p
              type="text"
              class="card-title p-0 m-0 w-100 shadow-none border-0"
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p class="p-0 m-0 text-wrap" [ngStyle]="sublableColor">
              {{ option.subhead }}
            </p>
            <p class="p-0 m-0 text-wrap" [ngStyle]="bodyColor">
              {{ option.body }}
            </p>
          </div>
        </div>

        <div
          *ngIf="styleP0 == 5"
          class="row m-0 p-0 d-flex align-items-center justify-content-center"
        >

          <div
            class="col-8 m-0 text-wrap mb-0"
            [ngStyle]="{ padding: fontSmaller ? '0px' : fontResize ? albums[1].padding : albums[0].padding }"
          >
            <p
              type="text"
              class="card-title p-0 m-0 w-100 shadow-none border-0"
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p class="p-0 m-0 text-wrap" [ngStyle]="sublableColor">
              {{ option.subhead }}
            </p>
            <p class="p-0 m-0 text-wrap" [ngStyle]="bodyColor">
              {{ option.body }}
            </p>
          </div>

          <div
            class="col-4 m-0"
            [ngStyle]="{ padding: fontSmaller ? '0px' :  fontResize ? albums[1].padding : albums[0].padding }"
          >
            <img
              [src]="option.image"
              class="object-fit-cover mx-auto d-block"
              [ngStyle]="{ width: widthP0 }"
              *ngIf="option.image"
              ngClass="{{ albums[0].image_round }}"
            />
          </div>
        </div>
      </ng-template>

      <ng-template #part_1>
        <div *ngIf="styleP1 == 0" class="row text-wrap -0 p-0">
          <div
            class="col-12 d-flex position-absolute top-50 start-50 translate-middle flex-column"
          >
            <p
              type="text"
              class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
              [ngClass]="
                label_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : label_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p
              class="p-0 m-0 d-flex shadow-none border-0 text-wrap"
              [ngStyle]="sublableColor"
              [ngClass]="
                sublabel_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : sublabel_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.subhead }}
            </p>
            <p
              class="p-0 m-0 d-flex shadow-none border-0 text-wrap"
              [ngStyle]="bodyColor"
              [ngClass]="
                body_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : body_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.body }}
            </p>
          </div>
        </div>
        <div *ngIf="styleP1 == 1" class="row text-wrap m-0 p-0">
          <div class="col-10 offset-1 text-center p-0 mb-0">
            <p
              type="text"
              class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
              [ngClass]="
                label_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : label_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p
              class="p-0 m-0 text-wrap d-flex"
              [ngStyle]="sublableColor"
              [ngClass]="
                sublabel_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : sublabel_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.subhead }}
            </p>
            <p
              class="p-0 m-0 text-wrap d-flex"
              [ngStyle]="bodyColor"
              [ngClass]="
                body_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : body_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.body }}
            </p>
          </div>
        </div>

        <!-- ********the image in background of the card with border has margin*********** -->
        <div
          *ngIf="styleP1 === 4"
          class="row px-2 m-0 h-100 d-flex justify-content-center"
        >
          <div class="col-12 p-0 m-0">
            <div
              class="card-img-overlay p-0 m-0"
              [ngStyle]="setImageP1(option.image)"
              ngClass="{{ albums[1].round }}"
              *ngIf="option.image"
            ></div>
          </div>
        </div>

        <!-- ********the image circle*********** -->
        <div *ngIf="styleP1 === 5" class="row m-0 p-0">
          <div
            class="col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle p-0 m-0 h-100"
          >
            <img
              [src]="imageOvel"
              class="object-fit-cover mx-auto d-block card-img p-0 m-0 h-100"
              style="width: 80%"
            />
            <div
              class="card-img-overlay position-absolute top-50 start-50 translate-middle m-0 p-0"
              style="width:{{ widthP0 }} ;"
            >
              <img
                [src]="option.image"
                class="mx-auto d-block p-0 m-0 h-100"
                style="border-radius: 50%; margin-bottom: 5% !important; aspect-ratio: 1;"
                *ngIf="option.image"
              />
              <div class="row text-wrap -0 p-0">
                <div class="col-12 d-flex flex-column">
                  <p
                    type="text"
                    class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
                    [ngClass]="
                      label_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : label_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                    [ngStyle]="lableColor(option)"
                  >
                    {{ option.headline }}
                  </p>
                  <p
                    class="p-0 m-0 text-center text-wrap"
                    [ngStyle]="sublableColor"
                    [ngClass]="
                      sublabel_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : sublabel_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                  >
                    {{ option.subhead }}
                  </p>
                  <p
                    class="p-0 m-0 text-center text-wrap"
                    [ngStyle]="bodyColor"
                    [ngClass]="
                      body_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : body_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                  >
                    {{ option.body }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="styleP1 === 7" class="row m-0 p-0">
          <div
            class="col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle p-0 m-0 h-100"
          >
            <img
              [src]="imageOvel"
              class="object-fit-cover mx-auto d-block card-img p-0 m-0 h-100"
              style="width: 80%"
            />
            <div
              class="card-img-overlay position-absolute top-50 start-50 translate-middle m-0 p-0"
              style="width:{{ widthP0 }} ; height: 100%;"
            >
              <div class="row text-wrap -0 p-0">
                <div class="col-12 d-flex flex-column" [ngClass]="fontSmaller ? '' : fontResize ? 'p-1' : 'p-2'">
                  <p
                    type="text"
                    class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
                    [ngClass]="
                      label_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : label_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                    [ngStyle]="lableColor(option)"
                  >
                    {{ option.headline }}
                  </p>
                  <p
                    class="p-0 m-0 text-center text-wrap"
                    [ngStyle]="sublableColor"
                    [ngClass]="
                      sublabel_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : sublabel_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                  >
                    {{ option.subhead }}
                  </p>
                  <p
                    class="p-0 m-0 text-center text-wrap"
                    [ngStyle]="bodyColor"
                    [ngClass]="
                      body_align === 'center'
                        ? 'justify-content-center align-items-center'
                        : body_align === 'right'
                          ? 'justify-content-end align-items-end'
                          : 'justify-content-start align-items-start'
                    "
                  >
                    {{ option.body }}
                  </p>
                </div>
              </div>
              <img
                [src]="option.image"
                class="mx-auto d-block p-0 m-0 h-75"
                style="margin-top: 3% !important"
                *ngIf="option.image"
              />

            </div>
          </div>
        </div>

        <!-- <div *ngIf="styleP1===6" class="row m-0 p-0">
          <div class=" col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle p-0 m-0 h-100" >
              <img [src]='imageOvel' class="object-fit-cover mx-auto d-block card-img p-0 m-0 h-100" style="width:80%; " >
             <div class="card-img-overlay position-absolute top-50 start-50 translate-middle m-0 p-0" style="width:{{widthP0}} ;">
              <img [src]='image' class="mx-auto d-block p-0 m-0 h-75" style="border-radius: 50%; margin-bottom: 5% !important;" *ngIf="image">
             </div>
          </div>
        </div> -->

        <div *ngIf="styleP1 === 6" class="row m-0 p-0">
          <div
            class="col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle p-0 m-0 h-100"
          >
            <img
              [src]="imageOvel"
              class="object-fit-cover mx-auto d-block card-img p-0 m-0 h-100"
              style="width: 85%"
            />
            <div
              class="card-img-overlay position-absolute top-50 start-50 translate-middle m-0 p-0"
              style="width:{{ widthP0 }} ; height: {{ widthP0 }};"
            >
              <img
                [src]="option.image"
                class="mx-auto d-block p-0 m-0 h-100"
                style="border-radius: 50%; margin-bottom: 5% !important"
                *ngIf="option.image"
              />
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #part_2>
        <div *ngIf="styleP2 == 1" class="row text-wrap m-0 p-0">
          <div class="col-10 offset-1 text-center p-0 mb-0">
            <p
              type="text"
              class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
              [ngClass]="
                label_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : label_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p
              class="p-0 m-0 text-wrap d-flex"
              [ngStyle]="sublableColor"
              [ngClass]="
                sublabel_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : sublabel_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.subhead }}
            </p>
            <p
              class="p-0 m-0 text-wrap d-flex"
              [ngStyle]="bodyColor"
              [ngClass]="
                body_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : body_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.body }}
            </p>
          </div>
        </div>

        <div *ngIf="styleP2 == 0" class="row text-wrap -0 p-0">
          <div
            class="col-12 d-flex position-absolute top-50 start-50 translate-middle flex-column"
          >
            <p
              type="text"
              class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
              [ngClass]="
                label_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : label_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
              [ngStyle]="lableColor(option)"
            >
              {{ option.headline }}
            </p>
            <p
              class="p-0 m-0 text-center text-wrap"
              [ngStyle]="sublableColor"
              [ngClass]="
                sublabel_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : sublabel_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.subhead }}
            </p>
            <p
              class="p-0 m-0 text-center text-wrap"
              [ngStyle]="bodyColor"
              [ngClass]="
                body_align === 'center'
                  ? 'justify-content-center align-items-center'
                  : body_align === 'right'
                    ? 'justify-content-end align-items-end'
                    : 'justify-content-start align-items-start'
              "
            >
              {{ option.body }}
            </p>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
